import React from 'react'
import Container from 'reactstrap/lib/Container'

interface Props {
  itemsProcessed: number
  totalItems: number
  updatedAt: string
  isInitialiasing: boolean
}

class BulkOperationsProgressBar extends React.Component<Props> {
  constructor(props: Props) {
    super(props)
  }

  render() {
    const basic = {
      width: '100%',
      height: '50px',
    }
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }
    const date = new Date(this.props.updatedAt)

    const customFormat: string = new Intl.DateTimeFormat('NL-nl', options).format(date)

    const labelStyle = {
      fontWeight: 500,
      color: 'var(--color-text-secondary, #555)',
    }

    const valueStyle = {
      fontWeight: 600,
      color: 'var(--color-text-primary, #333)',
    }
    const buttonContainer = {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      padding: '10px',
    }
    return (
      <Container fluid className="p-0" style={{ width: '100%', height: '100%' }}>
        <div style={{ flex: 1 }}>
          <progress value={this.props.itemsProcessed} max={this.props.totalItems} style={basic} />
          <div style={{ marginTop: '8px', marginBottom: '4px' }}>
            {this.props.isInitialiasing && <div style={{ marginBottom: '20px' }}>Operation is being initialised</div>}
          </div>
          <div style={buttonContainer}>
            <div style={{ marginBottom: '20px' }}>
              {this.props.itemsProcessed}/{this.props.totalItems} processed
            </div>
            <div>
              <span style={labelStyle}>Last updated at: </span>
              <span style={valueStyle}>{customFormat}</span>
            </div>
          </div>
        </div>
      </Container>
    )
  }
}

export default BulkOperationsProgressBar
